'use es6';

import { userPortal as userPortalLocalStorage, tryConvertLegacyStorage } from 'DesignData/lib/localStorage';
import { CUSTOM_MODULE_EDITOR_OPTIONS } from 'DesignData/enums/attributes/UserPortal';
const legacyKeySuffix = 'designeditorsui:customwidgeteditor:options';
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Object|Null}
 */

export function fetch(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, CUSTOM_MODULE_EDITOR_OPTIONS);
  return tryConvertLegacyStorage(storageClient, legacyKeySuffix, {
    async: false
  }) || storageClient.fetch();
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @param {Object} data
 * @returns {Promise}
 */

export function save(userId, portalId, data) {
  const storageClient = userPortalLocalStorage(userId, portalId, CUSTOM_MODULE_EDITOR_OPTIONS);
  return storageClient.saveAsync(data);
}